
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ContactFormHandler } from "@/components/ContactFormHandler";
import { ThankYouMessage } from "@/components/ThankYouMessage";

export const AppointmentForm = () => {
  return (
    <DialogContent className="sm:max-w-[425px]">
      <ContactFormHandler>
        {({ formData, setFormData, handleSubmit, loading, isSubmitted }) => (
          <>
            {isSubmitted ? (
              <ThankYouMessage />
            ) : (
              <>
                <DialogHeader>
                  <DialogTitle>Schedule Your Free Consultation</DialogTitle>
                  <DialogDescription>
                    Tell us about your business and automation needs. We'll get back to you within 24 hours.
                  </DialogDescription>
                </DialogHeader>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="space-y-2">
                    <Label htmlFor="name">Full Name *</Label>
                    <Input
                      id="name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      placeholder="Your full name"
                      required
                    />
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="email">Email *</Label>
                    <Input
                      id="email"
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      placeholder="your.email@company.com"
                      required
                    />
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="company">Company</Label>
                    <Input
                      id="company"
                      value={formData.company}
                      onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                      placeholder="Your company name"
                    />
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="phone">Phone Number</Label>
                    <Input
                      id="phone"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      placeholder="+44 7123 456789"
                    />
                  </div>
                  
                  <div className="space-y-2">
                    <Label htmlFor="message">Tell us about your automation needs *</Label>
                    <textarea
                      id="message"
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      placeholder="Describe the processes you'd like to automate..."
                      rows={4}
                      className="w-full px-3 py-2 border border-input rounded-md bg-background text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                      required
                    />
                  </div>
                  
                  <Button 
                    type="submit" 
                    className="w-full" 
                    disabled={loading}
                    onClick={() => console.log('AppointmentForm button clicked, form data:', formData)}
                  >
                    {loading ? "Sending..." : "Schedule Free Consultation"}
                  </Button>
                </form>
              </>
            )}
          </>
        )}
      </ContactFormHandler>
    </DialogContent>
  );
};
